import { Nullable } from '@ui/types/utility';
import { addMilliseconds } from 'date-fns';

import { MS_BEFORE_CLOSE_THRESHOLD } from '../config';

export enum MarketTiming {
  IS_OPEN,
  IS_OPEN_ABOUT_TO_CLOSE,
  IS_CLOSE,
}

export const getMarketTiming = (isOpen: boolean, nextClose: Nullable<Date>) => {
  const now = new Date();
  if (isOpen) {
    if (
      nextClose &&
      addMilliseconds(now, MS_BEFORE_CLOSE_THRESHOLD) > nextClose
    ) {
      return MarketTiming.IS_OPEN_ABOUT_TO_CLOSE;
    } else {
      return MarketTiming.IS_OPEN;
    }
  } else {
    return MarketTiming.IS_CLOSE;
  }
};
